import { SVGProps } from "react"

const LocationMark = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.30859 15.3646C8.30859 15.3646 13.3086 11.3646 13.3086 7.03125C13.3086 5.70517 12.7818 4.4334 11.8441 3.49572C10.9064 2.55803 9.63468 2.03125 8.30859 2.03125C6.98251 2.03125 5.71074 2.55803 4.77306 3.49572C3.83538 4.4334 3.30859 5.70517 3.30859 7.03125C3.30859 11.3646 8.30859 15.3646 8.30859 15.3646Z"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
    <path
      d="M8.30859 9.03125C8.57124 9.03125 8.83131 8.97952 9.07396 8.87901C9.31661 8.7785 9.53709 8.63118 9.72281 8.44546C9.90852 8.25975 10.0558 8.03927 10.1564 7.79662C10.2569 7.55397 10.3086 7.29389 10.3086 7.03125C10.3086 6.76861 10.2569 6.50853 10.1564 6.26588C10.0558 6.02323 9.90852 5.80275 9.72281 5.61704C9.53709 5.43132 9.31661 5.284 9.07396 5.18349C8.83131 5.08298 8.57124 5.03125 8.30859 5.03125C7.77816 5.03125 7.26945 5.24196 6.89438 5.61704C6.51931 5.99211 6.30859 6.50082 6.30859 7.03125C6.30859 7.56168 6.51931 8.07039 6.89438 8.44546C7.26945 8.82054 7.77816 9.03125 8.30859 9.03125V9.03125Z"
      stroke="#2F69FE"
      strokeWidth="1.2"
      strokeLinejoin="round"
    />
  </svg>
)

export default LocationMark
